import { createContext, useContext } from "react";

export interface SupportRequestScopeValue {
  openSupportRequest: () => void;
}

export const SupportRequestScopeContext =
  createContext<SupportRequestScopeValue | null>(null);

export const useSupportRequestScope = () =>
  useContext(SupportRequestScopeContext);
